import type { Project } from "../types/Project";

export const projects: Project[] = [
  {
    id: "okktav",
    title: "okKtav",
    summary: "Presentasjonsverktøy med sanntidsredigering og AI-assistent.",
    description: "Innholdsgenerasjonplatform ",
    features: [
      "Presentasjonsmotor bygget fra scratch",
      "Sanntidsredigering med Convex",
      "AI-assistent for innholdsgenerering",
      "Integrasjoner i Outlook, Vipps (innlogging), Sharepoint, & mer",
    ],
  },
];
